import BoostChart from './BoostChart';

export default BoostChart;
